import React from 'react'
import PropTypes from 'prop-types'

import api from './api'
import NotificationService from 'services/NotificationService'

import { Fade } from 'reactstrap'

import ImportFileUpload from './components/ImportFileUpload'
import ImportResult from './components/ImportResult'
import DownloadResult from './components/DownloadResult'

import './ImportDetail.scss'

class ImportDetail extends React.Component {
    static propTypes = {
        organisatie: PropTypes.object,
        notifyError: PropTypes.func,
        notifySuccess: PropTypes.func
    }

    static defaultProps = {
        organisatie: {}
    }

    state = {
        result: {},
        file: {},
        resultFileId: undefined,
        subject: undefined,
        isLoading: false
    }

    handleFileSelect = file => {
        this.setState({
            file,
            result: {},
            isLoading: false
        })
    }

    processAfdelingen = () => {
        this.setState({
            isLoading: true
        })

        api.processAfdelingen(this.props.organisatie.id, this.state.file).end((err, res) => {
            if (err) {
                NotificationService.notifyError({
                    title: 'Er is een fout opgetreden tijdens het verwerken.'
                })
                return
            }

            const { isSuccess, errorMessage, resultFileId } = res.body

            if (isSuccess !== true) {
                NotificationService.notifyError({
                    title: errorMessage
                })
                return
            }

            NotificationService.notifySuccess({
                message: 'Afdelingen succesvol verwerkt'
            })

            this.setState({
                subject: 'organisatieonderdelen',
                resultFileId,
                isLoading: false
            })
        })
    }

    importAfhandelaren = () => {
        this.setState({
            isLoading: true
        })

        api.importAfhandelaren(this.props.organisatie.id, this.state.file).end((err, res) => {
            if (err) {
                NotificationService.notifyError({
                    title: 'Fout tijdens import',
                    message: 'Er is een fout opgetreden tijdens het importeren van afhandelaren.'
                })
                return
            }

            this.setState({
                result: JSON.parse(res.text),
                subject: 'afhandelaren',
                isLoading: false
            })
        })
    }

    importMedewerkers = () => {
        this.setState({
            isLoading: true
        })

        api.importMedewerkers(this.props.organisatie.id, this.state.file).end((err, res) => {
            if (err) {
                NotificationService.notifyError({
                    title: 'Fout tijdens import',
                    message: 'Er is een fout opgetreden tijdens het importeren van medewerkers.'
                })

                return
            }

            this.setState({
                result: JSON.parse(res.text),
                subject: 'medewerkers',
                isLoading: false
            })
        })
    }

    render() {
        const { resultFileId } = this.state
        const actions = [
            {
                icon: 'calculator',
                title: 'Verwerk afdelingen',
                handle: this.processAfdelingen
            },
            {
                icon: 'upload',
                title: 'Importeer medewerkers',
                handle: this.importMedewerkers
            },
            {
                icon: 'upload',
                title: 'Importeer afhandelaren',
                handle: this.importAfhandelaren
            }
        ]

        return (
            this.props.organisatie && (
                <Fade className="ao-importdetail" tag="div">
                    <h3>{this.props.organisatie.organisatieNaam}</h3>

                    <ImportFileUpload
                        isLoading={ this.state.isLoading }
                        onFileSelect={ this.handleFileSelect }
                        actions={ actions }
                    />
                    <ImportResult result={ this.state.result } />
                    {resultFileId &&
                        this.state.subject && (
                        <DownloadResult
                            onError={ message => NotificationService.notifyError(message) }
                            onSuccess={ message => NotificationService.notifySuccess(message) }
                            subject={ this.state.subject }
                            resultFileId={ resultFileId }
                            isLoading={ this.state.isLoading }
                        />
                    )}
                </Fade>
            )
        )
    }
}

export default ImportDetail
